module.exports = __webpack_public_path__ + "static/img/bcg_anim_t.fdd1711f.png";